import React from 'react';

export default function StatCard({ label, value, sub, accent, icon, onClick, active }) {
  const clickable = typeof onClick === 'function';
  return (
    <div
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      style={{
      background: 'var(--navy-card)',
      border: `1px solid ${active ? 'var(--teal)' : 'var(--navy-border)'}`,
      borderRadius: 12,
      padding: '20px 24px',
      flex: 1,
      minWidth: 0,
      cursor: clickable ? 'pointer' : 'default',
      boxShadow: active ? '0 0 0 1px var(--teal)' : 'none',
      transition: 'border-color 0.15s, box-shadow 0.15s',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
        <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--gray-500)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          {label}
        </div>
        {icon && (
          <div style={{
            width: 32, height: 32, borderRadius: 8,
            background: accent === 'teal' ? 'var(--teal-dim)' : accent === 'gold' ? 'var(--gold-dim)' : 'rgba(26, 23, 20, 0.04)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: accent === 'teal' ? 'var(--teal)' : accent === 'gold' ? 'var(--gold)' : 'var(--gray-300)',
          }}>
            {icon}
          </div>
        )}
      </div>
      <div style={{
        fontSize: 28, fontWeight: 700, color: 'var(--white)', lineHeight: 1.1, marginBottom: 4,
      }}>
        {value}
      </div>
      {sub && (
        <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>{sub}</div>
      )}
    </div>
  );
}
